import React, { useState } from "react";
import BannerImage from "../../../assets/other_image/redefine_solution.jpg";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import BookDemoSection from "../PolarianALMSolution/BookDemoSection";
import { NavLink } from "react-router-dom";
import RedifiningPLMSolutionOverview from "./RedifiningPLMSolutionOverview";
import "./RedifiningPLMSolutionPage.css";
import { Helmet } from "react-helmet-async";

const faqData = [
  { question: "What is PLM redefinition?", answer: "PLM redefinition is the process of optimizing and realigning Teamcenter systems to ensure infrastructure, performance, and solutions match evolving business and IT requirements." },
  { question: "Why is redefining Teamcenter important?", answer: "As data grows and new Teamcenter releases are introduced, redefinition ensures your system remains efficient, scalable, and capable of delivering business value." },
  { question: "Can Nextech help with global Teamcenter deployments?", answer: "Yes. We provide global deployment strategies that align with business, IT, performance, and security needs." },
  { question: "Do I need to upgrade infrastructure to improve performance?", answer: "Not always. Nextech uses cost-effective tuning mechanisms to enhance performance before recommending expensive hardware upgrades." },
  { question: "What issues does PLM redefinition solve?", answer: "We address issues like poor query speeds, workflow failures, uncontrolled storage growth, weak performance tuning, and degraded rich client performance." },
  { question: "How long does a redefinition project take?", answer: "Timelines vary by system size and complexity — from a few weeks for specific optimizations to several months for full enterprise redefinition." },
  { question: "Does Nextech provide long-term PLM support?", answer: "Yes. We offer managed services for system monitoring, upgrades, scaling, and ongoing performance optimization." }
];

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    
    <div className="faq-item">
      <button className="faq-question" onClick={() => setOpen(!open)} aria-expanded={open}>
        <span>{question}</span>
        <span>{open ? "−" : "+"}</span>
      </button>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
};

const SectionHeader = ({ title, subtitle }) => (
  <header className="section-header">
    <h2 className="section-title">{title}</h2>
    {subtitle && <p className="section-subtitle">{subtitle}</p>}
  </header>
);

const TileGrid = ({ items }) => (
  <div className="tile-grid-3x2">
    {items.map((item, index) => (
      <article className="feature-tile" key={index}>
        {item.icon && (
          <div className="tile-icon">
            <img src={item.icon} alt={item.title} width="48" height="48" />
          </div>
        )}
        <h3 className="tile-title">{item.title}</h3>
        <p className="tile-content">{item.content}</p>
      </article>
    ))}
  </div>
);

const RedefinitionSolutionsPage = () => {
  const ourSolutionsItems = [
    { icon: "https://img.icons8.com/fluency/48/computer.png", title: "Infrastructure & Environments", content: "Evaluate and optimize hardware sizing, replication, consolidation, upgrades, and testing." },
  {
  icon: "https://img.icons8.com/color/48/merge.png",
  title: "System Interfaces & Integrations",
  content: "Redefine integrations for seamless data and application connectivity."
},
{
  icon: "https://img.icons8.com/color/48/internet.png",
  title: "Global Deployment Strategy",
  content: "Align PLM deployments with enterprise IT, security, and usability requirements."
},
    { icon: "https://img.icons8.com/fluency/48/performance.png", title: "Performance & Scalability", content: "Enhance speed and scalability through cost-effective tuning and optimization." },
    { icon: "https://img.icons8.com/fluency/48/security-checked.png", title: "Security Enhancements", content: "Strengthen security at metadata and file levels to meet compliance requirements." },
    { icon: "https://img.icons8.com/fluency/48/monitor.png", title: "System Monitoring & Health", content: "Establish proactive monitoring for reliability, stability, and uptime." }
  ];

  const whyNextechItems = [
    { icon: "https://img.icons8.com/fluency/48/process.png", title: "Unique Methodology", content: "A structured approach addressing integration, architecture, capability mapping, and performance challenges effectively." },
    { icon: "https://img.icons8.com/fluency/48/money-bag.png", title: "Cost-Effective Optimization", content: "Enhance system performance with tuning and scaling strategies before costly upgrades." },
    { icon: "https://img.icons8.com/fluency/48/maintenance.png", title: "Comprehensive Offerings", content: "From infrastructure evaluation and integrations to security and global deployment — end-to-end PLM transformation." },
   
{
  icon: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",  // ⭐ FIXED ICON
  title: "Expertise in Analysis & Redefinition",
  content: "Proven experience in assessing, restructuring, and optimizing Teamcenter systems for measurable business outcomes."
},


    { icon: "https://img.icons8.com/fluency/48/business.png", title: "Business Value Focus", content: "Align PLM redefinition with KPIs to ensure scalability, interoperability, compliance, and ROI." },
    { icon: "https://img.icons8.com/fluency/48/support.png", title: "Long-Term Support & Reliability", content: "Ongoing monitoring, performance tuning, and managed services to keep your Teamcenter environment future-ready." }
  ];

  const processSteps = [
    "Perform System Analysis – Review existing Teamcenter environment including hardware, network, configuration, performance, third-party apps, and datasets.",
    "Report on Redefinition Requirements – Identify gaps across system architecture and performance.",
    "Redefine for Business Goals – Align PLM deployment with IT, security, and usability requirements.",
    "Redefine Infrastructure – Scale hardware, optimize storage, and ensure version compatibility.",
    "Redefine System Integrations – Modernize integrations for seamless, efficient data flow.",
    "Redefine Security – Implement compliance-driven security at metadata and data levels.",
    "Redefine Solutions – Leverage new and enhanced Teamcenter features to meet business requirements.",
    "Enable ROI Improvement – Deliver measurable value through optimized system performance and efficiency."
  ];

  const plmChallenges = [
    "Data, application integration, and user growth",
    "Architectural changes from new Teamcenter releases",
    "Mapping new capabilities to business requirements",
    "Long query/data load times in tools like MCAD",
    "Rich client performance degradation due to user/data growth",
    "Frequent workflow hangs and process failures",
    "Storage overgrowth and poor scalability",
    "Weak performance tuning and lack of documentation",
    "Poor cross-team coordination in system administration, networking, and application support"
  ];

  return (
    <>
      {/* ✅ Meta Tags for SEO */}
  <Helmet>
    <title>Redefining PLM Solutions with Teamcenter in Pune | NexTech PLM</title>
    <meta name="description" content="Transform your PLM processes with Nextech PLM in Pune, India. Innovative Teamcenter solutions for enhanced productivity and collaboration." />
    <meta name="keywords" content="redefining PLM solutions, Teamcenter transformation Pune, next-gen PLM India, PLM digital transformation, Teamcenter modernization" />
    <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
    <link rel="canonical" href="https://nextechplm.com/teamcenter-redefining-plm-solution" />
    <meta property="og:site_name" content="NexTech PLM Solutions" />
    <meta property="og:type" content="website" />
    <meta property="og:title" content="Redefining PLM Solutions with Teamcenter in Pune | NexTech PLM" />
    <meta property="og:description" content="Transform your PLM processes with Nextech PLM in Pune, India. Innovative Teamcenter solutions for enhanced productivity and collaboration." />
    <meta property="og:url" content="https://nextechplm.com/teamcenter-redefining-plm-solution" />
    <meta name="twitter:title" content="Redefining PLM Solutions with Teamcenter in Pune | NexTech PLM" />
    <meta name="twitter:description" content="Transform your PLM processes with Nextech PLM in Pune, India. Innovative Teamcenter solutions for enhanced productivity and collaboration." />
</Helmet>

    <main className="polarion-solution-page">
      <Banner image={BannerImage} heading="Redefining PLM Solutions" />
      <FloatingContactUs />
      <RedifiningPLMSolutionOverview />

      <section className="section benefits-section">
        <div className="container">
          <div className="row g-4 align-items-center">
            
            {/* Benefits */}
            <div className="col-md-6 col-12">
              <div className="benefits-card">
                <h3 className="benefits-heading">Business Benefits of Redefining PLM with NexTech</h3>
                <ul className="benefits-list">
                  <li><span className="benefit-icon">✔</span> Maximize Teamcenter Usage – Unlock the full potential of your PLM system to support evolving business needs.</li>
                  <li><span className="benefit-icon">✔</span> Ensure Optimum Performance – Improve speed, scalability, and stability across Teamcenter environments.</li>
                  <li><span className="benefit-icon">✔</span> Leverage New Functionalities – Adopt enhanced features from new Teamcenter releases for added business value.</li>
                  <li><span className="benefit-icon">✔</span> Optimize Infrastructure – Scale hardware and architecture effectively with performance tuning before costly upgrades.</li>
                  <li><span className="benefit-icon">✔</span> Resolve System Issues – Eliminate bottlenecks like slow queries, degraded rich client performance, workflow hangs, and storage overgrowth.</li>
                  <li><span className="benefit-icon">✔</span> Strengthen Security & Compliance – Redefine data and metadata security in line with business, ITAR, and ADA compliance needs.</li>
                  <li><span className="benefit-icon">✔</span> Enhance ROI – Improve return on investment through cost-effective optimization and smarter deployments.</li>
                </ul>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-md-6 col-12 d-flex align-items-center">
              <div className="quick-links">
                <h4>Quick Links</h4>
                <ul>
                  <li><NavLink to={"/teamcenter/plm-document-management"}>Document Management</NavLink></li>
                  <li><NavLink to={"/teamcenter/manufacturing-data-process-management"}>Manufacturing Data and Process Management</NavLink></li>
                  <li><NavLink to={"/teamcenter/product-bom-variability-management"}>Product BOM and Variability Management</NavLink></li>
                  <li><NavLink to={"/teamcenter/community-collaboration"}>Teamcenter Community Collaboration</NavLink></li>
                  <li><NavLink to={"/teamcenter/cloud-implementation"}>Teamcenter Implementation on Cloud</NavLink></li>
                  <li><NavLink to={"/teamcenter/ecad-integration"}>ECAD Integration</NavLink></li>
                  <li><NavLink to={"/teamcenter/mcad-integration"}>MCAD Integration</NavLink></li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      <BookDemoSection />

      <section className="section featured-solutions-section">
        <div className="container">
          <SectionHeader title="Our PLM Redefinition Solutions" />
          <TileGrid items={ourSolutionsItems} />
        </div>
      </section>

      <section className="section our-solutions-section">
        <div className="container">
          <SectionHeader title="Why Choose NexTech for Redefining PLM Solutions?" />
          <p className="section-intro">
            At NexTech PLM Solutions, we go beyond routine PLM maintenance. We deliver strategic, cost-effective, and business-aligned redefinition of Teamcenter environments that maximize performance and business value.
          </p>
          <TileGrid items={whyNextechItems} />
          <p className="section-outro">
            With our proven track record and certified PLM experts, NexTech ensures your Teamcenter investment consistently drives business outcomes.
          </p>
        </div>
      </section>

      {/* New Section: NexTech's Unique Process for PLM Redefinition */}
      <section className="section nextech-process-section">
        <div className="container">
          <SectionHeader title="NexTech's Unique Process for PLM Redefinition" />
          <p className="section-intro">
            We follow a structured and transparent redefinition process to ensure clarity and measurable outcomes:
          </p>

          <div className="process-card">
            <ul className="process-list">
              {processSteps.map((step, index) => (
                <li key={index}>
                  <h4>Step {index + 1}</h4>
                  <p>{step}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="challenges-card">
            <SectionHeader title="PLM Challenges We Solve" />
            <ul className="challenges-list">
              {plmChallenges.map((challenge, index) => (
                <li key={index}>
                  <span className="challenge-icon">•</span> {challenge}
                </li>
              ))}
            </ul>
            <p className="section-outro">
              At NexTech, we redefine PLM systems to overcome these challenges and keep your Teamcenter environment reliable, scalable, and business-aligned.
            </p>
          </div>
        </div>
      </section>

      <section className="section faq-section">
        <div className="container">
          <SectionHeader title="Redefining PLM FAQs" />
          <div className="faq-container">
            {faqData.map((item, i) => (
              <FAQItem key={i} question={item.question} answer={item.answer} />
            ))}
          </div>
        </div>
      </section>

      <Letsgetintouch />
    </main>
  </>
  );
};

export default RedefinitionSolutionsPage;
